import { render, staticRenderFns } from "./TargetTypes.vue?vue&type=template&id=74b54d70&scoped=true&"
import script from "./TargetTypes.vue?vue&type=script&lang=ts&"
export * from "./TargetTypes.vue?vue&type=script&lang=ts&"
import style0 from "./TargetTypes.vue?vue&type=style&index=0&id=74b54d70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b54d70",
  null
  
)

export default component.exports